import { initialListPaginationMeta } from "utils/helpers/pagination";

import { RoofTypeForm, RoofTypeState } from "../types";

export const initialRoofTypeForm: RoofTypeForm = {
  number: "",
  description: "",
  maxHeight: "",
};

export const initialRoofTypeMeta = initialListPaginationMeta;

export const initialState: RoofTypeState = {
  loading: false,
  saving: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialRoofTypeMeta,
  error: null,
  isAddModalOpen: false,
  form: initialRoofTypeForm,
  detail: null,
  detailLoading: false,
  detailError: null,
};
